import {Grid} from '@material-ui/core';
import {List as IList, Map as IMap} from 'immutable';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {
  AccelDbRateFormatCd,
  GPLU_WHOLE_LIFE_FIELD_ID,
  GPLUCoverageCode,
  PwlRateFormatCd,
} from '../../../PlanTemplates/GWL/gpluConstants';
import {getGPLURatingBlockPropertyPaths} from '../PropertyPaths';

export const GPLURatingBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValues} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPathsPWL = getGPLURatingBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const handlePWLRateFormatCdChange = (e: React.ChangeEvent<{name?: string; value: unknown}>) => {
    const selectedPwlRateFormatCd = e.target.value as string;

    const coverageDefsPath = `benefitPackagingDetail.plans[${selectedPlan?.planIndex ?? 0}].coverageDefs`;
    const spouseCoverageIndex = getQuoteFieldValue<IList<IMap<string, any>>>(coverageDefsPath)?.findIndex(
      (cov: IMap<string, any>) => cov?.get('code') === GPLUCoverageCode.SPOUSE_WHOLE_LIFE
    );

    const accelCoverageIndex = getQuoteFieldValue<IList<IMap<string, any>>>(coverageDefsPath)?.findIndex(
      (cov: IMap<string, any>) => cov?.get('code') === GPLUCoverageCode.ACCEL_DEATH_BENEFIT_LIFE
    );

    let accelDbRateFormatCd: string;

    //[A360:KrakenRule] -> Update AccelDB rateFormatCd based on the value selected for PWL rateFormatCd
    if (accelCoverageIndex >= 0) {
      if (selectedPwlRateFormatCd === PwlRateFormatCd['AgeBanded-TobaccoDistinct']) {
        accelDbRateFormatCd = AccelDbRateFormatCd['AgeBanded-Uni-Tobacco'];
      }
      if (selectedPwlRateFormatCd === PwlRateFormatCd['AgeSpecific-TobaccoDistinct']) {
        accelDbRateFormatCd = AccelDbRateFormatCd['AgeSpecific-Uni-Tobacco'];
      }
    }

    updateQuoteFieldValues([
      {path: propertyPathsPWL.rateFormatCd, newValue: selectedPwlRateFormatCd},
      spouseCoverageIndex > -1 && {
        path: getGPLURatingBlockPropertyPaths(selectedPlan?.planIndex, spouseCoverageIndex).rateFormatCd,
        newValue: selectedPwlRateFormatCd,
      },
      accelCoverageIndex > -1 && {
        path: getGPLURatingBlockPropertyPaths(selectedPlan?.planIndex, accelCoverageIndex).rateFormatCd,
        newValue: accelDbRateFormatCd,
      },
    ]);
  };

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'row-a1cb4d10-8258-44af-9ef0-d4dfea970eee'},
      items: [
        {
          key: '1bb30360-c8ea-40f7-86cd-44baa97d3313',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="Rate Format"
              id={propertyPathsPWL.rateFormatCd}
              value={getQuoteFieldValue(propertyPathsPWL.rateFormatCd)}
              onChange={e => handlePWLRateFormatCdChange(e)}
              dropdownVariant="AttributeValue"
              searchKey="GPLUBenefitCoverageRatingDetails.rateFormatCd"
              formFieldId={GPLU_WHOLE_LIFE_FIELD_ID.rateFormatCd}
              coverageCode={GPLUCoverageCode.WHOLE_LIFE}
              required
            />
          ),
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Rating" collapsible expanded withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
